// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

const ListWrapper = styled<any, Theme>('ul')`
  padding: 0;
  margin: 0;
  outline: 0;
  list-style-type: none;
`;

export default ListWrapper;
